import { Box, colors, Typography, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { Button, type CustomButtonProps } from '~/components/Button';
import { ContentContainer } from '~/components/HomepageV3/styles';
import { usePlanLimits } from '~/hooks/usePlanLimits';

export const FooterCtaSection = () => {
  const [color, setColor] = useState<CustomButtonProps['color']>('primary');
  useEffect(() => {
    setTimeout(() => {
      setColor('white');
    }, 0);
  }, []);
  const planLimits = usePlanLimits();
  return (
    <ContentContainer sx={{ py: 12 }}>
      <CtaCard>
        <CtaShine />
        <CtaH1 sx={{ color: '#fff', position: 'relative' }}>
          Start analyzing technology adoption today
        </CtaH1>
        <CtaSub>
          Register for free to unlock {planLimits.registeredRows} rows per
          report. No card.
        </CtaSub>

        <Button
          color={color}
          type="submit"
          href="/signup"
          variant="contained"
          size="large">
          Register free
        </Button>
        <CtaTrust>
          We crawl our own data · We don't use data from resellers providers
        </CtaTrust>
      </CtaCard>
    </ContentContainer>
  );
};

const CtaCard = styled(Box)`
  background: linear-gradient(
    135deg,
    ${colors.blue[600]} 0%,
    ${colors.blue[800]} 100%
  );
  color: #fff;
  border-radius: 20px;
  padding: clamp(40px, 6vw, 72px);
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 24px 48px -16px rgba(15, 23, 42, 0.16);
`;

const CtaShine = styled(Box)`
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(
      ellipse 60% 40% at 80% 20%,
      rgba(255, 255, 255, 0.18),
      transparent 60%
    ),
    radial-gradient(
      ellipse 60% 40% at 10% 90%,
      rgba(0, 0, 0, 0.18),
      transparent 60%
    );
`;

const CtaH1 = styled(Typography)`
  font-size: clamp(32px, 4vw, 44px);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.1;
  margin: 0;
` as typeof Typography;

const CtaSub = styled(Typography)`
  color: rgba(255, 255, 255, 0.85);
  margin: 12px 0 28px;
  font-size: 17px;
  position: relative;
` as typeof Typography;

const CtaTrust = styled(Typography)`
  margin-top: 20px;
  font-size: 11px;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.7);
  position: relative;
` as typeof Typography;
